import createIcon from '../../createIcon';

/**
 * @component @name Filter3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMUg3QzUuOSAxIDUgMS45IDUgM1YxN0M1IDE4LjEgNS45IDE5IDcgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjNDMjMgMS45IDIyLjEgMSAyMSAxWk0yMSAxN0g3VjNIMjFWMTdaTTMgNUgxVjIxQzEgMjIuMSAxLjkgMjMgMyAyM0gxOVYyMUgzVjVaTTE3IDEzVjExLjVDMTcgMTAuNjcgMTYuMzMgMTAgMTUuNSAxMEMxNi4zMyAxMCAxNyA5LjMzIDE3IDguNVY3QzE3IDUuODkgMTYuMSA1IDE1IDVIMTFWN0gxNVY5SDEzVjExSDE1VjEzSDExVjE1SDE1QzE2LjEgMTUgMTcgMTQuMTEgMTcgMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Filter3 = createIcon('Filter3', [
  [
    'path',
    {
      d: 'M21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM17 13V11.5C17 10.67 16.33 10 15.5 10C16.33 10 17 9.33 17 8.5V7C17 5.89 16.1 5 15 5H11V7H15V9H13V11H15V13H11V15H15C16.1 15 17 14.11 17 13Z',
      key: '1fgo04',
    },
  ],
]);

export default Filter3;
